import React, { useEffect, useState } from "react";

function OptionL({ onInputChange, catid, namemain, mainid, defaultValuemain }){


    const [data, setData] = useState([])

    useEffect(() => {
        getdata()
    }, [])

    const getdata = async () => {
        const sendData = {
            OrgId: Number(2),
            UserId: Number(localStorage.getItem("userIdA")),
        }
        await fetch(process.env.REACT_APP_API_LINK + 'api/NCSCDA/DashboardDataAdmin', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    setData(data)
                    ////console.log(data)
                })


    };
  return (
   
              <select
               
                  className="form-control form-select"
                  name={namemain}
         
                  onChange={(e) => onInputChange(e)}

      >
       
          <option value="none" selected disabled>{defaultValuemain === "" || defaultValuemain === null ? "Select A option" : "Select A option"} </option>

          {data !== [] ? data.map(optiondata =>
              <option value={optiondata.userId} id={optiondata.id}> {optiondata.state}</option>
                ):null
              }
              </select>

         
  );
};

export default OptionL;
